import { CompanyServices } from '../../common/models/user.models';
import { ServiceConfiguration, ServiceConfigurations } from './state';

export function getSortedServiceConfigurationsByStatus(services: CompanyServices): ServiceConfiguration[][] {
  return ServiceConfigurations.reduce((acc, configuration) => {
    if (services[configuration.service]) {
      acc[0].push(configuration);
    } else {
      acc[1].push(configuration);
    }

    return acc;
  }, [[], []] as ServiceConfiguration[][]);
}
